import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/hooks/useAuth';

export type UserRole = 'kitchen' | 'service' | 'all' | null;

export function useRole() {
  const { user, loading: authLoading } = useAuth();
  const [role, setRole] = useState<UserRole>(null);
  const [restaurantId, setRestaurantId] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (authLoading) return;
    if (!user) {
      setRole(null);
      setRestaurantId(null);
      setLoading(false);
      return;
    }

    let cancelled = false;
    (async () => {
      const { data } = await supabase
        .from('profiles')
        .select('role, restaurant_id')
        .eq('id', user.id)
        .maybeSingle();
      if (cancelled) return;
      if (data && (data.role === 'kitchen' || data.role === 'service' || data.role === 'all')) {
        setRole(data.role as UserRole);
        setRestaurantId(data.restaurant_id);
      } else {
        setRole(null);
        setRestaurantId(null);
      }
      setLoading(false);
    })();

    return () => { cancelled = true; };
  }, [user, authLoading]);

  return { role, restaurantId, loading };
}
